import { defineMessages } from "react-intl";

export const cardMenuMessages = defineMessages({
  cardMenuItemLoading: {
    id: "9HSbdS",
    defaultMessage: "working...",
    description: "structure loading",
  },
});
